export default __webpack_public_path__ + "static/slide-2-3b6124f8e0c5acc7850fdace020c0c90.jpg";